import { ROUTER_MAP } from '@/types';


export const routerHistory = (set) => {
    return {
        routerHistory: [],
        setRouterHistory: (next: ROUTER_MAP[]) => {
            set(() => ({
                routerHistory: next,
            }));
        },
    };
};
